import {Outlet} from "react-router-dom";

function Data(){
    return(
        <div>
            <Outlet/>
        </div>
    )
}

export default Data;